import { registerControllers } from 'stimulus-vite-helpers';
import { Tabs, Modal } from 'tailwindcss-stimulus-components';
import { application } from './application';

const controllers = import.meta.glob('./**/*_controller.js', { eager: true });

registerControllers(application, controllers);

application.register('tabs', Tabs);
application.register('modal', Modal);
